import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HomeSection from './components/HomeSection';
import AboutSection from './components/AboutSection';
import CultureSection from './components/CultureSection';
import StorySection from './components/StorySection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function App() {
  const [activeTab, setActiveTab] = useState('home');

  // Scroll to top when tab changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeTab]);

  return (
    <div className="min-h-screen flex flex-col bg-navy-deep text-gray-100 font-sans selection:bg-amber-500 selection:text-navy-deep">
      
      {/* Navigation Header */}
      <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Main Content Area */}
      <main className="flex-1 py-6 px-3 sm:px-6 max-w-7xl mx-auto w-full">
        {activeTab === 'home' && <HomeSection setActiveTab={setActiveTab} />}
        {activeTab === 'about' && <AboutSection />}
        {activeTab === 'culture' && <CultureSection />}
        {activeTab === 'story' && <StorySection />}
        {activeTab === 'gallery' && <GallerySection />}
        {activeTab === 'contact' && <ContactSection />}
      </main>

      {/* Footer */}
      <Footer setActiveTab={setActiveTab} />

    </div>
  );
}
